var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhiteArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.718,
    height: 31.311,
    viewBox: "0 0 48.718 31.311",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4964",
    "data-name": "Group 4964",
    transform: "translate(-38.8 84.653) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M43.682,52.754h0a2.606,2.606,0,0,1-1.843-.763L28.791,38.94a2.606,2.606,0,1,1,3.686-3.685L43.682,46.462,54.889,35.254a2.606,2.606,0,0,1,3.686,3.686L45.525,51.99A2.606,2.606,0,0,1,43.682,52.754Z",
    transform: "translate(25.315 34.764)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_15",
    "data-name": "Line 15",
    d: "M1.6,45.175c-1.645,0-2.979-.841-2.979-1.879V.5C-1.379-.538-.046-1.38,1.6-1.38S4.578-.538,4.578.5V43.3C4.578,44.334,3.244,45.175,1.6,45.175Z",
    transform: "translate(67.398 40.18)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteArrow);
export default __webpack_public_path__ + "static/media/white-arrow.9653acedfdb2f90e355f5eeb6a6e528f.svg";
export { ForwardRef as ReactComponent };